// API Configuration
// Uses environment variable if available, otherwise defaults based on environment
//
// Para cambiar la URL en desarrollo local:
// 1. Crea un archivo .env.local en la raíz del proyecto
// 2. Agrega: REACT_APP_API_BASE_URL=https://api.aladdininsider.com
// 3. O para localhost: REACT_APP_API_BASE_URL=http://localhost:8000
// 4. Reinicia el servidor de desarrollo (npm start)

// Production API server (HTTPS via Nginx reverse proxy)
const PRODUCTION_URL = 'https://api.aladdininsider.com';
// Local development
const LOCAL_URL = 'http://localhost:8000';

// Determine API URL:
// 1. Use REACT_APP_API_BASE_URL if explicitly set (from .env.local or amplify.yml)
// 2. Use PRODUCTION_URL if in production build
// 3. Use LOCAL_URL for development
export const API_BASE_URL = 
  process.env.REACT_APP_API_BASE_URL || 
  (process.env.NODE_ENV === 'production' ? PRODUCTION_URL : LOCAL_URL);

// Log para debugging (solo en desarrollo)
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 API Base URL:', API_BASE_URL);
  console.log('💡 Para cambiar, crea .env.local con: REACT_APP_API_BASE_URL=<tu-url>');
}

